export default __webpack_public_path__ + "static/media/fridge1-before1-768w.f5a74e6e.webp";